import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CollectorModule } from '@nx-ahs/script-collector';
import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LayoutModule } from '../../../shared/components/layout/layout.module';

import { AddPrimaryPersonComponent } from './add-primary-person.component';

@NgModule({
	declarations: [AddPrimaryPersonComponent],
	exports: [AddPrimaryPersonComponent],
	imports: [
		CommonModule,
		IonicModule,
		CollectorModule,
		BaseTranslateModule,
		LayoutModule,
		FontAwesomeModule,
		FlexLayoutModule
	]
})
export class AddPrimaryPersonModule {}
